module.exports = ".table-svg {\n    position: relative;\n    top: 7px;\n    margin-right: 8px;\n}\n.table-svg.left{\n    fill: #a55024;\n}\n.table-svg.down{\n    fill: #dfa71c;\n}\n.table-svg.up{\n    fill: #268d19;\n}\n.table-svg.shuffle{\n    fill: #f86015;\n}\n.table-svg.settings-gears {\n    fill: #f23147;\n}\n.table-svg.rotate-back {\n    fill: #55247d;\n}\n\ncontainerSpinner {\n    position: relative;\n}\n.containerSpinner spinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/tanques/tanque-movimentacao-detail/tanque-movimentacao-detail.component.css
 ** module id = 603
 ** module chunks = 0
 **/